import React from 'react';
import './nlp.css';

const m_learning = () => {
    return (
        <div className="m_learning__wrap">
            <div className="m_learning container">
                <h3 className="m_learning--title">Natural Language Processing Block</h3>
                <p className="m_learning--text inner_pages--text">NLP has seen rapid advances in recent years. With some of the sharpest minds in data science presenting, get the latest insights, natural language processing training, trends, and discoveries in data science languages, tools, topics – and beyond.</p>
                <p className="m_learning--text inner_pages--text">Connect with some of the most innovative people and ideas in the world of data science, while learning first-hand from core practitioners and contributors. Learn about the latest advancements and trends in NLP, including pre-trained models, with use-cases focusing on deep learning, speech-to text, and semantic search.</p>
            </div>
        </div>
    );
};

export default m_learning;